import { Component } from '@angular/core';

@Component({
  selector: 'broker-decline-svg',
  templateUrl: './decline-svg.component.svg'
})
export class DeclineSvgComponent {}
